import type { DoorPlacement, WindowPlacement } from "building-types/openings/opening";
import type { Opening } from "building-types/openings/opening";

export const openingTypeToPrettyName: { [type in Opening["type"]]: string } = {
  WINDOW: "Window",
  WINDOW_V2: "Window",
  DOOR: "Door",
  DOOR_V2: "Door",
  SOLID: "Opening",
};

export function isWindowPlacement(opening: Opening): opening is WindowPlacement {
  return opening.type === "WINDOW" || opening.type === "WINDOW_V2";
}

export function isDoorPlacement(opening: Opening): opening is DoorPlacement {
  return opening.type === "DOOR" || opening.type === "DOOR_V2";
}
